import { applyPackageDetails, PRODUCT_NAME } from './package-details.js';

/**
 * Scroll to a form section and, when the CTA names a product this form offers,
 * select it and carry the CTA's package label into input[name="package_details"].
 *
 * The scroll is unconditional. A CTA that names no product, or names one the
 * form does not offer, still takes the visitor to the form — it just leaves the
 * existing product selection alone rather than blanking it, and drops the
 * package label, which would otherwise describe a product that is not selected.
 *
 * Clearing the label when the visitor later changes product is handled by
 * package-details.js, which guards every form on load.
 *
 * @param {{ package?: string|null, packageDetails?: string|null, formSectionId?: string|null }} detail
 */
export function scrollToFormAndSelectProduct(detail = {}) {
    const packageValue = detail.package ?? null;
    const packageDetails = detail.packageDetails ?? null;
    const sectionId = detail.formSectionId || 'join-us-form';
    const section = document.getElementById(sectionId);

    if (!section) {
        return;
    }

    const form = section.querySelector('form');

    if (form) {
        const radios = packageValue
            ? Array.from(form.querySelectorAll('input[name="' + PRODUCT_NAME + '"]'))
            : [];

        const target = radios.find(function (radio) {
            return radio.value === packageValue;
        }) ?? null;

        if (target) {
            // Record the label before ticking the radio: the change event
            // dispatched below compares against it.
            applyPackageDetails(form, packageValue, packageDetails);

            radios.forEach(function (radio) {
                radio.checked = radio === target;
            });

            target.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
            applyPackageDetails(form, null, null);
        }
    }

    const prefersReduced =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const topOffset = 100;
    const targetTop =
        section.getBoundingClientRect().top + window.scrollY - topOffset;

    window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: prefersReduced ? 'auto' : 'smooth',
    });
}
